import React, { useEffect, useState } from 'react';
import { LeftToolGroupSt } from './LeftToolGroup';

const OpenCsv = ({ objectPolygon }) => {
  const [isShow, setIsShow] = useState(true);
  const [data, setData] = useState<{ group: string; geometry: number[][] }[]>([]);
  const onChange = (e) => {
    if (e.target.files.length) {
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onload = (evt) => {
        const str = String(evt.target!.result);
        const row = str.split('\r\n');
        const newArr: { group: string; geometry: number[][] }[] = [];
        row.map((i) => {
          const group = i.split(',')[0];
          const lat = Number(i.split(',')[1]);
          const lon = Number(i.split(',')[2]);
          if (!!newArr.filter((i) => group === i.group).length) {
            newArr.find((i) => i.group === group)?.geometry.push([lat, lon]);
          } else {
            newArr.push({ group, geometry: [[lat, lon]] });
          }
        });
        setData(newArr);
      };
      fileReader.readAsText(file, 'euc-kr');
    } else {
      setData([]);
    }
  };

  const onToggleLayer = () => {
    setIsShow(!isShow);
  };

  const onDestroy = () => {
    objectPolygon?.destroyCsvPolygon();
    (document.getElementById('divideField') as any).value = null;
    setData([]);
  };

  useEffect(() => {
    objectPolygon?.onToggleCsvLayer(isShow);
  }, [isShow]);

  useEffect(() => {
    if (data) {
      objectPolygon?.drawCsvPolygon(data);
    }
  }, [data]);

  return (
    <>
      {!!data.length ? (
        <>
          <LeftToolGroupSt.UploadBtn type={'button'} onClick={onDestroy} style={{ marginRight: 6 }}>
            초기화
          </LeftToolGroupSt.UploadBtn>
          <LeftToolGroupSt.UploadBtn type={'button'} onClick={onToggleLayer}>
            {isShow ? '숨기기' : '보이기'}
          </LeftToolGroupSt.UploadBtn>
        </>
      ) : (
        <LeftToolGroupSt.UploadLabel htmlFor={'divideField'}>업로드</LeftToolGroupSt.UploadLabel>
      )}
      <input id={'divideField'} type={'file'} multiple={false} onChange={onChange} style={{ display: 'none' }} />
    </>
  );
};

export default OpenCsv;
